import { Space } from '../../../components/core-v2'
import { AssetCard } from '../../../components/core-v2/molecules/asset-card'
import { AssetFull } from '../types'

export type AssetsViewProps = {
  assets: AssetFull[]
  onSelectAsset: (assetId: string) => void
  selectedAsset?: AssetFull
}

const AssetsView = (props: AssetsViewProps) => {
  const { assets } = props
  const { selectedAsset } = props
  const { onSelectAsset } = props

  return (
    <Space mt={3}>
      <ul>
        {assets.map(asset => (
          <AssetCard
            key={asset.asset.assetId}
            assetId={asset.asset.assetId}
            assetName={asset.asset.name}
            isInUse={asset.assetIsInUse}
            isSelected={selectedAsset && asset.asset.assetId === selectedAsset.asset.assetId}
            onClickAsset={() => onSelectAsset(asset.asset.assetId)}
          />
        ))}
      </ul>
    </Space>
  )
}

export default AssetsView
